import { TableLoader } from 'dyl-components';
import React from 'react';
import { useSelector } from 'react-redux';
import { Table as SemanticTable } from 'semantic-ui-react';
import { PhoneUtil } from 'utils';

const SessionSubTable = ({ session_id }) => {
    const { users, isReading } = useSelector(state => state.campaign_session_summary.dialerCampaignSessions[session_id] ||  { users: [], isReading: false });
    return (
        <SemanticTable compact className='CampaignSessionSummary__subTable'>
            <SemanticTable.Header>
                <SemanticTable.Row>
                    <SemanticTable.HeaderCell>User</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell># Calls</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>Total Call Time</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>Connected</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>Not Connected</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>Voicemail Drop</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>Disconnected Number</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>Missed Attempt</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>No-Answer</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>Busy</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>Transferred</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>Abandoned</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>Missed</SemanticTable.HeaderCell>
                </SemanticTable.Row>
            </SemanticTable.Header>
            <SemanticTable.Body>
                {!isReading ? users?.map((user, idx) => (
                    <SemanticTable.Row key={idx}>
                        <SemanticTable.Cell>{user.username}</SemanticTable.Cell>
                        <SemanticTable.Cell>{user.call_info?.total ?? 0}</SemanticTable.Cell>
                        <SemanticTable.Cell>{user.call_info?.talk_time ? PhoneUtil.timeTicker(user.call_info?.talk_time) : "00:00:00"}</SemanticTable.Cell>
                        <SemanticTable.Cell>{user.call_info?.connected ?? 0}</SemanticTable.Cell>
                        <SemanticTable.Cell>{user.call_info?.notconnected ?? 0}</SemanticTable.Cell>
                        <SemanticTable.Cell>{user.call_info?.voicemail_drop ?? 0}</SemanticTable.Cell>
                        <SemanticTable.Cell>{user.call_info?.disconnected ?? 0}</SemanticTable.Cell>
                        <SemanticTable.Cell>{user.call_info?.missedattempt ?? 0}</SemanticTable.Cell>
                        <SemanticTable.Cell>{user.call_info?.notanswered ?? 0}</SemanticTable.Cell>
                        <SemanticTable.Cell>{user.call_info?.busy ?? 0}</SemanticTable.Cell>
                        <SemanticTable.Cell>{user.call_info?.transfer ?? 0}</SemanticTable.Cell>
                        <SemanticTable.Cell>{user.call_info?.abandoned ?? 0}</SemanticTable.Cell>
                        <SemanticTable.Cell>{user.call_info?.missed ?? 0}</SemanticTable.Cell>
                    </SemanticTable.Row>
                )) : (
                    <SemanticTable.Row>
                        <TableLoader colspan={13} isLoading />
                    </SemanticTable.Row>
                )}
            </SemanticTable.Body>
        </SemanticTable>
    );
};

export default SessionSubTable;
